import * as types from './types';

const initialState = {
  YusaOvernightCampProgramAndPropertyList: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };

    case types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampProgramAndProperty: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_FAILURE:
      return { ...state, error: action.payload };
    case types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_SUCCESS: {
      return {
        ...state,
        YusaOvernightCampProgramAndPropertyList: action.payload
      };
    }
    case types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_FAILURE:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
